import script from "./ReportFolderAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportFolderAccordion.vue?vue&type=script&setup=true&lang=ts"

import "./ReportFolderAccordion.vue?vue&type=style&index=0&id=1981e9fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1981e9fb"]])

export default __exports__